import { useResource } from "../../../services";
import { ParticipantExam } from "../../../types/components";
import { useUserContext } from "../../contexts/UserProvider";
import { today } from "../../date";
import { createResourceUrl } from "../../data";

export const useStartingExam = () => {
  const { user } = useUserContext();
  const { data, mutate, isLoading, isError } = useResource<[ParticipantExam]>(
    createResourceUrl("/common/participant-exam", {
      include: [
        "exam",
        "exam.exam_type",
        "exam.status",
        "exam.responsible_persons",
        "exam.responsible_persons.responsible_person",
      ],
      filters: {
        "eq:participant_id": user?.id,
        "gteDateTime:exam.date_to": today,
        "eq:exam.status.code": "scheduled",
        "eq:exam.is_finished": 0,
        "userInsuranceCompany:1": "exam.insurance_company.agents",
        "eq:exam.is_archived": 0,
        "eq:is_completed": 0,
      },
      sort: "exam.date_from",
      per_page: 1,
    }),
    user,
  );

  return {
    data,
    mutate,
    isLoading,
    isError,
  };
};
